// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement("img");
  overlayImage.setAttribute("src", `${image.src}`);
  overlay = document.createElement("div");
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = "50%";
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = "100%";
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute("class", "image-magnify-full-size");
  container.setAttribute("aria-hidden", "true");
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = "var(--gradient-background)";
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(
    `.loading-overlay__spinner`
  );
  if (loadingSpinner) {
    loadingSpinner.classList.toggle("hidden");
  }
}

let isZoomActive = false;

function moveWithHover(image, event, zoomRatio) {
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  let xPosition, yPosition;

  if (event.type.startsWith('touch')) {
    xPosition = event.touches[0].clientX - container.left;
    yPosition = event.touches[0].clientY - container.top;
  } else {
    xPosition = event.clientX - container.left;
    yPosition = event.clientY - container.top;
  }

  // Ensure xPosition and yPosition are within the image bounds
  xPosition = Math.max(0, Math.min(xPosition, image.clientWidth));
  yPosition = Math.max(0, Math.min(yPosition, image.clientHeight));

  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  const carouselSlides = document.querySelector('.product__media-wrapper .carousel__slides');

  overlay.onclick = () => {
    overlay.remove();
    carouselSlides.classList.remove('no-overflow-x');
    isZoomActive = false;
  };
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => {
    overlay.remove();
    carouselSlides.classList.remove('no-overflow-x');
    isZoomActive = false;
  };
  overlay.ontouchstart = (event) => moveWithHover(image, event, zoomRatio);
  overlay.ontouchmove = (event) => {
    event.preventDefault();
    moveWithHover(image, event, zoomRatio);
  };

  // Add the class to prevent horizontal overflow
  carouselSlides.classList.add('no-overflow-x');
  isZoomActive = true;
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll(".image-magnify-hover");
  images.forEach((image) => {
    const wrapper = image.closest(".product-media-container");
    const button = wrapper.querySelector(".product__media-icon--lightbox");
    const imageElement = image.querySelector("img");
    if (button) {
      button.onclick = (event) => {
        magnify(imageElement, zoomRatio);
        moveWithHover(imageElement, event, zoomRatio);
      };
    
      button.ontouchstart = (event) => {
        magnify(imageElement, zoomRatio);
        moveWithHover(imageElement, event, zoomRatio);
      };
    
      button.ontouchmove = (event) => {
        if (isZoomActive) {
          event.preventDefault();
          moveWithHover(imageElement, event, zoomRatio);
        }
      };
    }

    imageElement.ontouchmove = (event) => {
      if (isZoomActive) {
        event.preventDefault();
        moveWithHover(imageElement, event, zoomRatio);
      }
    };
  });
}

enableZoomOnHover(2);